import React from "react";
import Button from "components/ui/Button";
import Icon from "components/ui/Icon";
import { faClockRotateLeft } from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components";
import i18next from "i18next";

const SuffixWrap = styled.div`
  height: 30px;
`;

const DescriptionWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export function getVariableDefaultValue(variable) {
  const value = variable?.value || variable?.defaultValue;
  if (variable?.format === "boolean" && variable?.inputType !== "dropdown") {
    return value === "true";
  }
  return value || "";
}

export function getVariableDetails(
  { name, profileName } = {},
  profileVariables = []
) {
  return profileVariables.find(
    (profileVariable) =>
      profileVariable.name === name &&
      profileVariable.profile.name === profileName
  );
}

export const extractVariablesFromProfiles = (profiles = []) => {
  return profiles.reduce((accumulator, profile) => {
    const variables = profile?.variables || [];
    variables.forEach((variable) => {
      accumulator.push({
        ...variable,
        options: (variable?.options || []).map((option) => ({
          ...option,
          value: option.label,
          canonicalValue: option.value,
        })),
        profile: {
          name: profile.metadata.name,
          uid: profile.metadata.uid,
          type: profile?.spec?.published?.type,
          version: profile.spec.version,
        },
      });
    });

    return accumulator;
  }, []);
};

function getFieldKind(variable) {
  if (variable.inputType === "dropdown") return "dropdown";
  if (variable.format === "boolean") return "boolean";
  if (variable.isSensitive) return "masked";
  if (variable.format === "number") return "number";
  return "string";
}

export function getFieldPropsFromVariable({
  prefix,
  variable,
  readOnly = false,
  fieldValue,
  onUseDefaultValue = () => {},
  defaultButtonLabel = "",
  hideLabel = false,
}) {
  const hasDefaultValue = fieldValue === variable.defaultValue;
  const showUseDefault =
    !readOnly &&
    !hasDefaultValue &&
    !!variable.defaultValue &&
    !variable.immutable;
  const kind = getFieldKind(variable);

  return {
    name: `${prefix}.${variable?.guid}.value`,
    ...(!hideLabel && { label: variable.displayName }),
    description:
      hasDefaultValue && variable.defaultValue
        ? i18next.t("Uses default value")
        : "",
    helperText: variable.description,
    required: !!variable?.required,
    kind,
    readOnly: readOnly || !!variable?.immutable,
    suffix: (
      <SuffixWrap>
        {showUseDefault ? (
          <Button
            data-qa="use-default-button"
            onClick={onUseDefaultValue}
            secondary={true}
          >
            <Icon awesome={faClockRotateLeft} />
            <span>{defaultButtonLabel || i18next.t("Use Default")}</span>
          </Button>
        ) : null}
      </SuffixWrap>
    ),
    ...(kind === "dropdown" && {
      options: (variable?.options || []).map((option) => {
        return {
          ...option,
          ...((option.description ||
            (option.canonicalValue && !variable?.isSensitive)) && {
            description: (
              <DescriptionWrap>
                {!variable?.isSensitive ? (
                  <span>Value: {option.canonicalValue}</span>
                ) : null}
                {option.description ? (
                  <span>Description: {option.description}</span>
                ) : null}
              </DescriptionWrap>
            ),
          }),
        };
      }),
    }),
  };
}
